import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

interface AudioInvalidSelectionDialogProps {
  isOpen: boolean;
  handleClose: () => void;
  text: string;
}

export const AudioInvalidSelectionDialog = ({
  isOpen,
  handleClose,
  text,
}: AudioInvalidSelectionDialogProps) => {
  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          data-testid="dialog-title"
          title="Audio file not selectable"
        >
          Audio file not selectable
        </ModalHeader>
        <ModalBody data-testid="dialog-content">{text}</ModalBody>
        <ModalFooter data-testid="dialog-actions">
          <Button onClick={handleClose} p={3}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
